export interface State {
    token: string;
}

// TODO Make token null initially
export const initialState: State = {
    token: '',
};
